import { render, staticRenderFns } from "./ProjectRolesRow.vue?vue&type=template&id=bcc82bb2&scoped=true&"
import script from "./ProjectRolesRow.vue?vue&type=script&lang=ts&"
export * from "./ProjectRolesRow.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectRolesRow.vue?vue&type=style&index=0&id=bcc82bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc82bb2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcc82bb2')) {
      api.createRecord('bcc82bb2', component.options)
    } else {
      api.reload('bcc82bb2', component.options)
    }
    module.hot.accept("./ProjectRolesRow.vue?vue&type=template&id=bcc82bb2&scoped=true&", function () {
      api.rerender('bcc82bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/ProjectRolesRow.vue"
export default component.exports